import { render, staticRenderFns } from "./SpinnerContainer.vue?vue&type=template&id=12976068&"
import script from "./SpinnerContainer.vue?vue&type=script&lang=js&"
export * from "./SpinnerContainer.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerContainer.vue?vue&type=style&index=0&id=12976068&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports